(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationSquaresController', OrganisationSquaresController);

    OrganisationSquaresController.$inject = ['$scope', '$timeout', '$state', 'ProfileCategory', 'Profile', 'Principal', 'Connexion', 'Position'];

    function OrganisationSquaresController($scope, $timeout, state, ProfileCategory, Profile, Principal, Connexion, Position) {
        var vm = this;
        vm.state = state;
        vm.selectedPosition = this.selectedPosition;
        vm.organisation = this.organisation;



        vm.profile = this.profile;

        vm.slicedPositions = [];
        vm.slicePositions = slicePositions;


        if (vm.profile) {
            vm.currentPositions = vm.profile.positions.filter(function(val) {
                return val.active == true;
            });

            // Move the selected position to the Front of the list
            if (vm.selectedPosition){
                vm.currentPositions.forEach(function(pos,i){
                    if(pos.id === vm.selectedPosition.id){
                        vm.currentPositions.splice(i, 1);
                        vm.currentPositions.unshift(pos);
                    }
                });
            }
            slicePositions(); 
        }

        function slicePositions() {
            var index = 0;
            if (vm.slicedPositions.length == 0) {
                index = 0;
            } else {
                index = vm.currentPositions.indexOf(vm.slicedPositions[2]) + 1;
            }

            if (index == vm.currentPositions.length) {
                index = 0;
            }

            var end = index + 3;


            vm.slicedPositions = vm.currentPositions.slice(index, end);

            // On complète les blancs si on arrive à la fin
            if (vm.slicedPositions.length == 1 && vm.currentPositions.length > 1) {

                vm.slicedPositions.push(vm.currentPositions[0]);
                vm.slicedPositions.push(vm.currentPositions[1]);
            } else if (vm.slicedPositions.length == 2 && vm.currentPositions.length > 2) {
                vm.slicedPositions.push(vm.currentPositions[0]);
            }
            vm.selectedPosition = vm.slicedPositions[0];
        }

        vm.categories = [];
        vm.switchSquare = switchSquare;
        vm.connect = connect;
        vm.loadPage = loadPage;


        $scope.$watch('vd.organisation', function(newValue, oldValue) {
            if (!newValue || angular.equals(newValue, oldValue)) {
                return;
            }

            if (newValue)
                console.log("I see a data change!");
            init();

        });


        if (vm.organisation) init();

        function init() {

            vm.organisation.employees = {};
            vm.mode = 0;
            vm.hasNextPage = {
                1: false,
                2: false,
                3: false,
                4: false
            };

            vm.totalCount = {
                1: 0,
                2: 0,
                3: 0,
                4: 0
            };


            vm.page = {
                1: 1,
                2: 1,
                3: 1,
                4: 1
            };


            keepFocus();
            $timeout(goToBottom, 0, false);
            ProfileCategory.query(function(profileCategories) {
                vm.categories = profileCategories.filter(function(profileCategory) {
                    return profileCategory.company === (vm.organisation.type === 'company');
                });
                vm.categories.forEach(function(category) {
                    Profile.category({
                        categoryId: category.id,
                        organisationId: vm.organisation.id
                    }, function(profiles, headers) {
                        if (!vm.organisation.employees) {
                            vm.organisation.employees = {};
                        }
                        vm.hasNextPage[category.order] = headers('X-Has-Next-Page') === "true";
                        vm.totalCount[category.order] = headers('X-Total-Count');
                        vm.organisation.employees[category.order] = profiles;
                    });
                });
            });
        }

        function switchSquare(newActiveSquare) {
            vm.mode = newActiveSquare;
        }

        function keepFocus() {
            $('.focus-out').blur(function() {
                vm.focus = false;
                $timeout(function() {
                    if (!vm.focus) {
                        vm.mode = '';
                        $scope.$apply();
                    } else {
                        vm.focus = false;
                    }
                }, 200);
            });

            $('.inner-container').click(function(evt) {
                console.log('keep focus');
                vm.focus = true;
            });
        }

        function goToBottom() {
            var a = angular.element("#inner-bottom-left");
            var b = angular.element("#inner-bottom-right");
            a.prop({ scrollTop: a.prop("scrollHeight") });
            b.prop({ scrollTop: b.prop("scrollHeight") });
        }


        function connect(profile, newGrade) {
            if (profile.connectionId) {
                updateGrade(profile, newGrade);
            } else {
                insertGrade(profile, newGrade);
            }
        }

        function insertGrade(profile, newGrade) {
            var connection = {
                creator: {
                    id: vm.profileId
                },
                grade: newGrade,
                target: {
                    id: profile.id
                }
            };
            Connexion.save(connection, function(res) {
                profile.grade = res.grade;
                profile.connectionId = res.id;
            }, angular.noop);
        }

        function updateGrade(profile, newGrade) {
            var connection = {
                id: profile.connectionId,
                creator: {
                    id: vm.profileId
                },
                grade: newGrade,
                target: {
                    id: profile.id
                }
            };
            Connexion.update(connection, function(res) {
                profile.grade = newGrade;
            });
        }

        function loadPage(page, categoryOrder) {
            vm.page[categoryOrder] = page;
            var category = vm.categories.filter(function(category) {
                return category.order === categoryOrder;
            })[0];
            Profile.category({
                page: vm.page[categoryOrder] - 1,
                categoryId: category.id,
                organisationId: vm.organisation.id
            }, function(profiles, headers) {
                vm.hasNextPage[category.order] = headers('X-Has-Next-Page') === "true";
                vm.totalCount[category.order] = headers('X-Total-Count');
                vm.organisation.employees[category.order] = vm.organisation.employees[category.order].concat(profiles);
            });
        }
    }
})();